import styled from "styled-components"

const Dot = styled.div`
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%; 
  ${({color}) => color && `
  background-color: ${color};
`}
  margin-left: 7px;
`
export default Dot
